
/* injects from baggage-loader */

'use strict';

import AccountWidgetController from './account-widget.controller';
import AccountWidgetTemplate from './account-widget.html';

export default class AccountWidgetComponent {
		constructor() {
				this.templateUrl = AccountWidgetTemplate;
				this.controller = AccountWidgetController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					icon: '=',
					lineOne: '=',
					lineTwo: '=',
					gradient: '='
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/components/account-widget/account-widget.component.js